import React, { Component } from "react"
import Reveal from "react-reveal/Reveal"

import styles from "./styles.module.less"
// import WorkDropDown from "./WorkDropDown"

import Grid from "./Grid"
import { Link } from "gatsby"

import sluggo from "../../../util/slug"

import tacoPoster from "./img/taco-img.jpg"
import tacoLogo from "./img/taco-logo.jpg"

import bePoster from "./img/be-img.jpg"
import beLogo from "./img/be-logo.jpg"

import emergingLeadersPoster from "./img/EmergingLeaders-img.jpg"
import emergingLeadersLogo from "./img/EmergingLeaders-logoImg.jpg"

import adobePoster from "./img/Adobe_Desktop.jpg"
import adobeLogo from "./img/Adobe_Desktop_Hover.jpg"

import kmnPoster from "./img/KMN_Desktop.png"
import kmnLogo from "./img/KMN_Desktop_Hover.png"

import OCSPPoster from "./img/OCSP.png"
import OCSPLogo from "./img/OCSP-logo.png"

const blogEnabled = !!process.env.BLOG_ENABLED

export default class Work extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ...props,
    }
  }

  delete = id => {
    this.setState(prevState => ({
      group: prevState.group.filter(discipline => discipline != id),
    }))
  }

  renderThoughts = () => {}
  render() {
    let studies = [
      {
        img: OCSPPoster,
        logo: OCSPLogo,
        headline: "OCSP: Campaigning to create awareness. ",
        name: "Oregon College Savings Plan",
        casestudy: "/case-studies/oregon-college-savings-plan",
      },
      {
        img: adobePoster,
        logo: adobeLogo,
        headline: "Adobe: Approaching SEO as editorial.",
        name: "Adobe",
        casestudy: "/case-studies/adobe-seo/",
      },
      {
        img: kmnPoster,
        logo: kmnLogo,
        headline: "Know Me Now: Branding a social movement.",
        name: "Know Me Now",
        casestudy: "/case-studies/know-me-now/",
      },

      {
        img: tacoPoster,
        logo: tacoLogo,
        headline: "Taco Bell: Personalizing ecommerce.",
        name: "Taco Bell",
        casestudy: "/case-studies/tacobell/",
      },
      {
        img: bePoster,
        logo: beLogo,
        headline: "Bay Equity: Building a new home.",
        name: "Bay Equity",
        casestudy: "/case-studies/be/",
      },
      {
        img: emergingLeadersPoster,
        logo: emergingLeadersLogo,
        headline: "Emerging Leaders: Defining a new identity.",
        name: "Emerging Leaders",
        casestudy: "/case-studies/eli/",
      },
    ]
    const {
      discipline = "",
      posts,
      selectedDisciplines,
      pathname,
      group,
    } = this.props
    const disciplinedPosts = posts.filter(post => {
      return selectedDisciplines.includes(post.disciplines)
    })
    const showBlog = blogEnabled && disciplinedPosts.length > 0
    // console.log(showBlog, !!process.env.BLOG_ENABLED, disciplinedPosts.length)
    return (
      <div className={styles.Work}>
        <Reveal>
          <div className={styles.header}>
            <h1>Real work.</h1>
          </div>

          <div className={styles.Studies}>
            <h2>Studies</h2>
            <div className={styles.wrapper}>
              {studies.map((study, key) => (
                <div className={styles.study} key={key}>
                  <div className={styles.img}>
                    <Link to={study.casestudy}>
                      <img
                        src={study.img}
                        alt={study.name}
                        onMouseOver={e => (e.currentTarget.src = study.logo)}
                        onMouseOut={e => (e.currentTarget.src = study.img)}
                      />
                    </Link>
                  </div>
                  <h3>{study.headline}</h3>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
        {showBlog && (
          <Reveal>
            <div id="thoughts" className={styles.Bites}>
              <h2>Thoughts {discipline}</h2>
              <div>
                <ul className={styles.disciplines}>
                  <li className={styles.discipline}>
                    <Link to={`/work/#thoughts`}>See all</Link>
                  </li>
                  <Discipline
                    discipline={discipline}
                    selected={selectedDisciplines}
                    available={group}
                    pathname={pathname}
                  />
                </ul>
              </div>
              <div className={styles.grid}>
                <Grid posts={disciplinedPosts} />
              </div>
            </div>
          </Reveal>
        )}
      </div>
    )
  }
}

class Discipline extends React.Component {
  getDeleteHref = discipline => {
    const { pathname, selected, available } = this.props
    const qs = new URLSearchParams()
    qs.append(
      "disciplines",
      selected
        .filter(d => available.find(at => at.fieldValue === d))
        .filter(d => d !== discipline.fieldValue)
        .join(",")
    )
    return `${pathname}?${qs.toString()}#thoughts`
  }

  render() {
    const { available, selected } = this.props
    const filtered = available.filter(discipline =>
      selected.includes(discipline.fieldValue)
    )
    return (
      <div className={styles.disciplines}>
        {filtered.map(discipline => (
          <li className={styles.discipline} key={discipline.fieldValue}>
            <Link
              to={`/disciplines/${sluggo(discipline.fieldValue)}/#thoughts`}
            >
              {discipline.fieldValue}
            </Link>
            <Link
              className={styles.deleteTrigger}
              to={this.getDeleteHref(discipline)}
              replace
            >
              ×
            </Link>
          </li>
        ))}
      </div>
    )
  }
}
